import { Box, Fade } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useRecoilState } from 'recoil';
import { PanIcon } from '~/assets/workspace-icons';
import ToolbarButton from '~/components/toolbar/shared/ToolbarButton';
import ToolPropertiesTray from '~/components/toolbar/shared/ToolPropertiesTray';
import PanToolOptions from './PanToolOptions';
import { selectedToolState } from '~/state/atoms/toolsAtoms';

export default function PanTool() {
    const [tool, setTool] = useRecoilState(selectedToolState);
    const [hovered, setHovered] = useState(false);
    const enterTimeout = useRef<ReturnType<typeof setTimeout>>();
    const leaveTimeout = useRef<ReturnType<typeof setTimeout>>();
    const intl = useIntl();

    const handleMouseEnter = () => {
        clearTimeout(leaveTimeout.current);
        enterTimeout.current = setTimeout(() => setHovered(true), 500);
    };

    const handleMouseLeave = () => {
        clearTimeout(enterTimeout.current);
        leaveTimeout.current = setTimeout(() => setHovered(false), 150);
    };

    useEffect(() => {
        return () => {
            clearTimeout(enterTimeout.current);
            clearTimeout(leaveTimeout.current);
        };
    }, []);

    return (
        <Box
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            sx={{ position: 'relative' }}
        >
            <ToolbarButton
                icon={<PanIcon />}
                tooltip={intl.formatMessage({
                    id: 'toolbar.pan.tooltip',
                })}
                tooltipPlacement="left"
                selected={tool === 'pan'}
                onClick={() => setTool('pan')}
                data-testid="tool-pan"
            />
            <Fade
                in={hovered}
                timeout={{ enter: 200, exit: 150 }}
                unmountOnExit
            >
                <ToolPropertiesTray
                    placement="parent"
                    sx={(theme) => ({
                        background: 'rgba(4, 20, 32, 0.88)',
                        border: `1px solid ${theme.palette.primary.main}`,
                    })}
                >
                    <PanToolOptions />
                </ToolPropertiesTray>
            </Fade>
        </Box>
    );
}
